import React, { useRef, useEffect } from "react";
import { Box } from "@mui/material";

interface CameraNativeProps {
  onCapture: (imageSrc: string) => void;
  onClose: () => void;
}

const CameraNative: React.FC<CameraNativeProps> = ({ onCapture, onClose }) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [isProcessing, setIsProcessing] = React.useState(false);
  const triggeredRef = useRef(false);

  useEffect(() => {
    // Trigger only once per mount
    if (!triggeredRef.current && fileInputRef.current) {
      triggeredRef.current = true;
      fileInputRef.current.click();
    }
  }, []);

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (file) {
      setIsProcessing(true);
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64data = reader.result as string;
        onCapture(base64data);
        setIsProcessing(false);
      };
      reader.onerror = () => {
        setIsProcessing(false);
        onClose();
      };
      reader.readAsDataURL(file);
    } else {
      // User cancelled - close immediately
      onClose();
    }

    // Reset input
    e.target.value = "";
  };

  return (
    <Box sx={{ display: "none" }}>
      <input
        type="file"
        accept="image/*"
        capture="environment"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
    </Box>
  );
};

export default CameraNative;